// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__NBMDH","skeleton-circle":"Skeleton_skeleton-circle__nJ8OA","shimmer":"Skeleton_shimmer__hrgpI"};